// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jgji","input":"styles_input__2WqIJ"};